/**
 * This file is generated by `pnpm codegen` from the OpenAPI spec, DO NOT EDIT.
 */

import { makeData } from 'core/types/makeData'

import * as ResponseTypes from '../responses/types'
import * as SchemaTypes from '../schema/types'
import * as UtilityTypes from '../utilities/types'

import * as TransactionsInternalTypes from './types'

export type TransactionsGetInternalKey = ['transactions', unknown]

export type TransactionsGetInternalResponse =
  ResponseTypes.TransactionCollection

export type TransactionsGetInternalVariables = {
  body?: void
  query?: {
    /**
     * @default
     *     25
     */
    limit?: number
    startingAfter?: string
    status?: SchemaTypes.TransactionStatus
    statuses?: Array<SchemaTypes.TransactionStatus>
    scheduledBefore?: string
    paymentType?: 'ach' | 'debitCard' | 'creditCard'
    paymentTypes?: Array<'ach' | 'debitCard' | 'creditCard'>
    process?: 'scheduledMicrodeposits' | 'refunded' | 'pendingReversals' | 'raw'
    autopayExpectedPaymentIds?: Array<string>
    isExternal?: boolean
  }
}

export const transactionsGetInternal = makeData<
  TransactionsGetInternalResponse,
  TransactionsGetInternalKey,
  TransactionsGetInternalVariables
>({
  method: 'get',
  name: 'transactionsGetInternal',
  summary: 'Get all transactions',
  path: '/transactions',
  queryKey: ({ query }) => ['transactions', query],
})

export type TransactionsUpdateInternalKey = ['transactions', unknown]

export type TransactionsUpdateInternalResponse = {
  /** Whether all pending ACH transactions have been processed. */
  done: boolean
  lastPendingAt?: /** The timestamp of the last remaining pending ACH transaction, if any. */
  | string /** The timestamp of the last remaining pending ACH transaction, if any. */
    | null
}

export type TransactionsUpdateInternalVariables = {
  body?:
    | Array<any>
    | {
        entries?: Array<{
          type?: 'transaction' | 'microdeposit' | 'microdepositReversal'
          id?: string
          amount?: number
          processingfeeAmount?: number
          processingFeeType?: 'gross' | 'net'
          status?: SchemaTypes.TransactionStatus
          failureReason?: SchemaTypes.TransactionFailureReason
        }>
      }
  query?: {
    process?:
      | 'scheduled'
      | 'pending'
      | 'pendingReversals'
      | 'achConfirmation'
      | 'chargeback'
      | 'autopay'
      | 'service'
  }
}

export const transactionsUpdateInternal = makeData<
  TransactionsUpdateInternalResponse,
  TransactionsUpdateInternalKey,
  TransactionsUpdateInternalVariables
>({
  method: 'post',
  name: 'transactionsUpdateInternal',
  summary: 'Update processed transactions',
  path: '/transactions',
  queryKey: ({ query }) => ['transactions', query],
})

export type TransactionsGetInitiatedAchInternalKey = [
  'transactions',
  'initiated',
  unknown,
]

export type TransactionsGetInitiatedAchInternalResponse =
  ResponseTypes.TransactionCollection

export type TransactionsGetInitiatedAchInternalVariables = {
  body?: void
  query?: {
    /**
     * @default
     *     25
     */
    limit?: number
    startingAfter?: string
    paymentProcessorId: SchemaTypes.AnyId
  }
}

export const transactionsGetInitiatedAchInternal = makeData<
  TransactionsGetInitiatedAchInternalResponse,
  TransactionsGetInitiatedAchInternalKey,
  TransactionsGetInitiatedAchInternalVariables
>({
  method: 'get',
  name: 'transactionsGetInitiatedAchInternal',
  summary: 'Get initiated ACH transactions.',
  path: '/transactions/initiated',
  queryKey: ({ query }) => ['transactions', 'initiated', query],
})

export type TransactionsUpdateInitiatedAchInternalKey = [
  'transactions',
  'initiated',
  unknown,
]

export type TransactionsUpdateInitiatedAchInternalResponse = void

export type TransactionsUpdateInitiatedAchInternalVariables = {
  body?: {
    /** The card number. Must provide at least first 4 digits of the card number. */
    cardNumber?: string
  }
  query?: void
}

export const transactionsUpdateInitiatedAchInternal = makeData<
  TransactionsUpdateInitiatedAchInternalResponse,
  TransactionsUpdateInitiatedAchInternalKey,
  TransactionsUpdateInitiatedAchInternalVariables
>({
  method: 'post',
  name: 'transactionsUpdateInitiatedAchInternal',
  summary: 'Update processed ACH transactions.',
  path: '/transactions/initiated',
  queryKey: ({ query }) => ['transactions', 'initiated', query],
})

export type TransactionsCreateRefundServiceCreditInternalKey = [
  'transactions',
  'refund',
  unknown,
]

export type TransactionsCreateRefundServiceCreditInternalResponse = void

export type TransactionsCreateRefundServiceCreditInternalVariables = {
  body?: {
    amount: number
    drawId: string
  }
  query?: void
}

export const transactionsCreateRefundServiceCreditInternal = makeData<
  TransactionsCreateRefundServiceCreditInternalResponse,
  TransactionsCreateRefundServiceCreditInternalKey,
  TransactionsCreateRefundServiceCreditInternalVariables
>({
  method: 'post',
  name: 'transactionsCreateRefundServiceCreditInternal',
  summary: 'Create service credit of type refund for LOC purchase',
  path: '/transactions/refund',
  queryKey: ({ query }) => ['transactions', 'refund', query],
})

export type TransactionsCreateRoundingServiceCreditInternalKey = [
  'transactions',
  'rounding',
  unknown,
]

export type TransactionsCreateRoundingServiceCreditInternalResponse = void

export type TransactionsCreateRoundingServiceCreditInternalVariables = {
  body?: {
    loanId: string
    amount: number
  }
  query?: void
}

export const transactionsCreateRoundingServiceCreditInternal = makeData<
  TransactionsCreateRoundingServiceCreditInternalResponse,
  TransactionsCreateRoundingServiceCreditInternalKey,
  TransactionsCreateRoundingServiceCreditInternalVariables
>({
  method: 'post',
  name: 'transactionsCreateRoundingServiceCreditInternal',
  summary: 'Create service credit of type `rounding`',
  path: '/transactions/rounding',
  queryKey: ({ query }) => ['transactions', 'rounding', query],
})

export type InternalTransactionsGetLoanIdsKey = [
  'transactions',
  'loan-ids',
  unknown,
]

export type InternalTransactionsGetLoanIdsResponse = {}

export type InternalTransactionsGetLoanIdsVariables = {
  body?: Array<string | number>
  query?: void
}

export const internalTransactionsGetLoanIds = makeData<
  InternalTransactionsGetLoanIdsResponse,
  InternalTransactionsGetLoanIdsKey,
  InternalTransactionsGetLoanIdsVariables
>({
  method: 'post',
  name: 'internalTransactionsGetLoanIds',
  summary:
    'Get the loans associated with a list of transaction. Returns a map from transaction public ID to loan public ID. Null values represent transactions with no associated loan.',
  path: '/transactions/loan-ids',
  queryKey: ({ query }) => ['transactions', 'loan-ids', query],
})

export type TransactionsGetAllExpiredHoldDaysKey = [
  'transactions',
  'expired-hold-days',
  unknown,
]

export type TransactionsGetAllExpiredHoldDaysResponse =
  ResponseTypes.TransactionCollection

export type TransactionsGetAllExpiredHoldDaysVariables = {
  body?: void
  query?: {
    checkDate: string
    catchUp?: boolean
    /**
     * @default
     *     25
     */
    limit?: number
    startingAfter?: string
    endingBefore?: string
  }
}

export const transactionsGetAllExpiredHoldDays = makeData<
  TransactionsGetAllExpiredHoldDaysResponse,
  TransactionsGetAllExpiredHoldDaysKey,
  TransactionsGetAllExpiredHoldDaysVariables
>({
  method: 'get',
  name: 'transactionsGetAllExpiredHoldDays',
  summary:
    'Transactions that have an expired hold_days_end_date and are either initiated or pending status.',
  path: '/transactions/expired-hold-days',
  queryKey: ({ query }) => ['transactions', 'expired-hold-days', query],
})

export type MicrodepositsGetScheduledInternalKey = [
  'transactions',
  'microdeposits',
  unknown,
]

export type MicrodepositsGetScheduledInternalResponse =
  ResponseTypes.MicrodepositCollection

export type MicrodepositsGetScheduledInternalVariables = {
  body?: void
  query?: {
    /**
     * @default
     *     25
     */
    limit?: number
    startingAfter?: string
    paymentProcessorId: SchemaTypes.AnyId
  }
}

export const microdepositsGetScheduledInternal = makeData<
  MicrodepositsGetScheduledInternalResponse,
  MicrodepositsGetScheduledInternalKey,
  MicrodepositsGetScheduledInternalVariables
>({
  method: 'get',
  name: 'microdepositsGetScheduledInternal',
  summary: 'Get scheduled microdeposits',
  path: '/transactions/microdeposits',
  queryKey: ({ query }) => ['transactions', 'microdeposits', query],
})

export type TransactionsUpdateMicrodepositsInternalKey = [
  'transactions',
  'microdeposits',
  unknown,
]

export type TransactionsUpdateMicrodepositsInternalResponse = void

export type TransactionsUpdateMicrodepositsInternalVariables = {
  body?: Array<{}>
  query?: void
}

export const transactionsUpdateMicrodepositsInternal = makeData<
  TransactionsUpdateMicrodepositsInternalResponse,
  TransactionsUpdateMicrodepositsInternalKey,
  TransactionsUpdateMicrodepositsInternalVariables
>({
  method: 'post',
  name: 'transactionsUpdateMicrodepositsInternal',
  summary: 'Update processed microdeposits.',
  path: '/transactions/microdeposits',
  queryKey: ({ query }) => ['transactions', 'microdeposits', query],
})

export type MicrodepositsSendRemindersKey = [
  'transactions',
  'microdeposits',
  'reminders',
  unknown,
]

export type MicrodepositsSendRemindersResponse = void

export type MicrodepositsSendRemindersVariables = {
  body?: {}
  query?: void
}

export const microdepositsSendReminders = makeData<
  MicrodepositsSendRemindersResponse,
  MicrodepositsSendRemindersKey,
  MicrodepositsSendRemindersVariables
>({
  method: 'post',
  name: 'microdepositsSendReminders',
  summary: 'Send microdeposit reminders.',
  path: '/transactions/microdeposits/reminders',
  queryKey: ({ query }) => [
    'transactions',
    'microdeposits',
    'reminders',
    query,
  ],
})

export type TransactionsCancelScheduledInternalKey = [
  'companies',
  string | undefined,
  'cancel-scheduled-transactions',
  unknown,
]

export type TransactionsCancelScheduledInternalResponse = void

export type TransactionsCancelScheduledInternalVariables = {
  companyId: string | undefined
  body?: void
  query?: {
    scheduledBefore?: string
    paymentType?: 'ach' | 'debitCard' | 'creditCard'
    paymentTypes?: Array<'ach' | 'debitCard' | 'creditCard'>
  }
}

export const transactionsCancelScheduledInternal = makeData<
  TransactionsCancelScheduledInternalResponse,
  TransactionsCancelScheduledInternalKey,
  TransactionsCancelScheduledInternalVariables
>({
  method: 'post',
  name: 'transactionsCancelScheduledInternal',
  summary: 'Cancel scheduled transactions',
  path: '/companies/{companyId}/cancel-scheduled-transactions',
  queryKey: ({ query, companyId }) => [
    'companies',
    companyId,
    'cancel-scheduled-transactions',
    query,
  ],
})

export type ProcessScheduledReversalsForLoanKey = [
  'companies',
  string | undefined,
  'loans',
  string | undefined,
  'scheduled-reversals',
  unknown,
]

export type ProcessScheduledReversalsForLoanResponse = void

export type ProcessScheduledReversalsForLoanVariables = {
  companyId: string | undefined
  loanId: string | undefined
  body?: void
  query?: {
    scheduledBefore?: string
  }
}

export const processScheduledReversalsForLoan = makeData<
  ProcessScheduledReversalsForLoanResponse,
  ProcessScheduledReversalsForLoanKey,
  ProcessScheduledReversalsForLoanVariables
>({
  method: 'post',
  name: 'processScheduledReversalsForLoan',
  summary: 'Process scheduled reversals for loan',
  path: '/companies/{companyId}/loans/{loanId}/scheduled-reversals',
  queryKey: ({ query, companyId, loanId }) => [
    'companies',
    companyId,
    'loans',
    loanId,
    'scheduled-reversals',
    query,
  ],
})

export type GetReconciliationTransactionsByCompanyKey = [
  'companies',
  string | undefined,
  'transactions',
  unknown,
]

export type GetReconciliationTransactionsByCompanyResponse =
  ResponseTypes.ReconciliationTransactionCollection

export type GetReconciliationTransactionsByCompanyVariables = {
  companyId: string | undefined
  body?: void
  query?: {
    /**
     * @default
     *     25
     */
    limit?: number
    startingAfter?: string
    endingBefore?: string
    status?: Array<SchemaTypes.TransactionStatusReadOnly>
    toEffectiveDate?: string
    fromEffectiveDate?: string
    investorId?: SchemaTypes.AnyId
    transferSettlementId?: SchemaTypes.AnyId
    transactionType?: 'reconciliation'
  }
}

export const getReconciliationTransactionsByCompany = makeData<
  GetReconciliationTransactionsByCompanyResponse,
  GetReconciliationTransactionsByCompanyKey,
  GetReconciliationTransactionsByCompanyVariables
>({
  method: 'get',
  name: 'getReconciliationTransactionsByCompany',
  summary:
    'Generic endpoint for getting transactions related to a company. Currently used for getting reconciliation transactions.',
  path: '/companies/{companyId}/transactions',
  queryKey: ({ query, companyId }) => [
    'companies',
    companyId,
    'transactions',
    query,
  ],
})

export type CreateReconciliationKey = [
  'companies',
  string | undefined,
  'transactions',
  unknown,
]

export type CreateReconciliationResponse = UtilityTypes.SingletonResponse & {
  data?: SchemaTypes.Transaction
}

export type CreateReconciliationVariables = {
  companyId: string | undefined
  body?: SchemaTypes.ReconciliationTransaction
  query?: {
    investorId: SchemaTypes.AnyId
  }
}

export const createReconciliation = makeData<
  CreateReconciliationResponse,
  CreateReconciliationKey,
  CreateReconciliationVariables
>({
  method: 'post',
  name: 'createReconciliation',
  summary:
    'Create transactions related to settlements and investors, such as a reconciliation transaction.',
  path: '/companies/{companyId}/transactions',
  queryKey: ({ query, companyId }) => [
    'companies',
    companyId,
    'transactions',
    query,
  ],
})

export type CompanyTransactionsGetTransitionalKey = [
  'companies',
  string | undefined,
  'transactions',
  'auto-transition',
  unknown,
]

export type CompanyTransactionsGetTransitionalResponse =
  ResponseTypes.TransactionCollection

export type CompanyTransactionsGetTransitionalVariables = {
  companyId: string | undefined
  body?: void
  query?: {
    /**
     * @default
     *     25
     */
    limit?: number
    startingAfter?: string
    endingBefore?: string
    paymentType:
      | 'ach'
      | 'debitCard'
      | 'creditCard'
      | 'check'
      | 'cash'
      | 'payroll'
      | 'paymentNetwork'
  }
}

export const companyTransactionsGetTransitional = makeData<
  CompanyTransactionsGetTransitionalResponse,
  CompanyTransactionsGetTransitionalKey,
  CompanyTransactionsGetTransitionalVariables
>({
  method: 'get',
  name: 'companyTransactionsGetTransitional',
  summary:
    'Transactions that may be due for automatic transitioning from pending',
  path: '/companies/{companyId}/transactions/auto-transition',
  queryKey: ({ query, companyId }) => [
    'companies',
    companyId,
    'transactions',
    'auto-transition',
    query,
  ],
})

export type TransactionsBackdateForDeadzoneKey = [
  'companies',
  string | undefined,
  'people',
  string | undefined,
  'loans',
  string | undefined,
  'transactions',
  string | undefined,
  'backdate-for-deadzone',
  unknown,
]

export type TransactionsBackdateForDeadzoneResponse = void

export type TransactionsBackdateForDeadzoneVariables = {
  companyId: string | undefined
  personId: string | undefined
  loanId: string | undefined
  transactionId: string | undefined
  body?: void
  query?: void
}

export const transactionsBackdateForDeadzone = makeData<
  TransactionsBackdateForDeadzoneResponse,
  TransactionsBackdateForDeadzoneKey,
  TransactionsBackdateForDeadzoneVariables
>({
  method: 'post',
  name: 'transactionsBackdateForDeadzone',
  summary: 'Backdate transactions in light of deadzone, if needed',
  path: '/companies/{companyId}/people/{personId}/loans/{loanId}/transactions/{transactionId}/backdate-for-deadzone',
  queryKey: ({ query, companyId, personId, loanId, transactionId }) => [
    'companies',
    companyId,
    'people',
    personId,
    'loans',
    loanId,
    'transactions',
    transactionId,
    'backdate-for-deadzone',
    query,
  ],
})

export type TransactionsDeleteChildrenKey = [
  'companies',
  string | undefined,
  'people',
  string | undefined,
  'loans',
  string | undefined,
  'transactions',
  string | undefined,
  'delete-children',
  unknown,
]

export type TransactionsDeleteChildrenResponse = void

export type TransactionsDeleteChildrenVariables = {
  companyId: string | undefined
  personId: string | undefined
  loanId: string | undefined
  transactionId: string | undefined
  body?: void
  query?: void
}

export const transactionsDeleteChildren = makeData<
  TransactionsDeleteChildrenResponse,
  TransactionsDeleteChildrenKey,
  TransactionsDeleteChildrenVariables
>({
  method: 'post',
  name: 'transactionsDeleteChildren',
  summary: 'Delete child virtual transactions',
  path: '/companies/{companyId}/people/{personId}/loans/{loanId}/transactions/{transactionId}/delete-children',
  queryKey: ({ query, companyId, personId, loanId, transactionId }) => [
    'companies',
    companyId,
    'people',
    personId,
    'loans',
    loanId,
    'transactions',
    transactionId,
    'delete-children',
    query,
  ],
})

export type TransactionsZeroSplitsKey = [
  'companies',
  string | undefined,
  'people',
  string | undefined,
  'loans',
  string | undefined,
  'transactions',
  string | undefined,
  'zero-splits',
  unknown,
]

export type TransactionsZeroSplitsResponse = void

export type TransactionsZeroSplitsVariables = {
  companyId: string | undefined
  personId: string | undefined
  loanId: string | undefined
  transactionId: string | undefined
  body?: void
  query?: void
}

export const transactionsZeroSplits = makeData<
  TransactionsZeroSplitsResponse,
  TransactionsZeroSplitsKey,
  TransactionsZeroSplitsVariables
>({
  method: 'post',
  name: 'transactionsZeroSplits',
  summary: 'Zero out transaction splits',
  path: '/companies/{companyId}/people/{personId}/loans/{loanId}/transactions/{transactionId}/zero-splits',
  queryKey: ({ query, companyId, personId, loanId, transactionId }) => [
    'companies',
    companyId,
    'people',
    personId,
    'loans',
    loanId,
    'transactions',
    transactionId,
    'zero-splits',
    query,
  ],
})

export type TransactionsCreateVirtualKey = [
  'companies',
  string | undefined,
  'people',
  string | undefined,
  'loans',
  string | undefined,
  'virtual-transactions',
  unknown,
]

export type TransactionsCreateVirtualResponse =
  UtilityTypes.SingletonResponse & {
    data?: SchemaTypes.Transaction
  }

export type TransactionsCreateVirtualVariables = {
  companyId: string | undefined
  personId: string | undefined
  loanId: string | undefined
  body?: TransactionsInternalTypes.CreateVirtualTransaction
  query?: void
}

export const transactionsCreateVirtual = makeData<
  TransactionsCreateVirtualResponse,
  TransactionsCreateVirtualKey,
  TransactionsCreateVirtualVariables
>({
  method: 'post',
  name: 'transactionsCreateVirtual',
  summary: 'Create virtual transaction',
  path: '/companies/{companyId}/people/{personId}/loans/{loanId}/virtual-transactions',
  queryKey: ({ query, companyId, personId, loanId }) => [
    'companies',
    companyId,
    'people',
    personId,
    'loans',
    loanId,
    'virtual-transactions',
    query,
  ],
})

export type TransactionsCreateVirtualsSetKey = [
  'companies',
  string | undefined,
  'loans',
  string | undefined,
  'transactions',
  string | undefined,
  'virtual-transaction-set',
  unknown,
]

export type TransactionsCreateVirtualsSetResponse = void

export type TransactionsCreateVirtualsSetVariables = {
  companyId: string | undefined
  loanId: string | undefined
  transactionId: string | undefined
  body?: TransactionsInternalTypes.RequestBodyVirtualTransactionSetPost
  query?: void
}

export const transactionsCreateVirtualsSet = makeData<
  TransactionsCreateVirtualsSetResponse,
  TransactionsCreateVirtualsSetKey,
  TransactionsCreateVirtualsSetVariables
>({
  method: 'post',
  name: 'transactionsCreateVirtualsSet',
  summary: 'Create complete virtual transaction set',
  path: '/companies/{companyId}/loans/{loanId}/transactions/{transactionId}/virtual-transaction-set',
  queryKey: ({ query, companyId, loanId, transactionId }) => [
    'companies',
    companyId,
    'loans',
    loanId,
    'transactions',
    transactionId,
    'virtual-transaction-set',
    query,
  ],
})

export type GetLoanDataForApplyPaymentsKey = [
  'companies',
  string | undefined,
  'people',
  string | undefined,
  'loans',
  string | undefined,
  'loan-data-for-apply-payments',
  unknown,
]

export type GetLoanDataForApplyPaymentsResponse =
  ResponseTypes.LoanDataForApplyPayments

export type GetLoanDataForApplyPaymentsVariables = {
  companyId: string | undefined
  personId: string | undefined
  loanId: string | undefined
  body?: void
  query?: {
    creatingMessageId?: string
    isReplay?: boolean
    effectiveAt?: string
    transactionId?: string
  }
}

export const getLoanDataForApplyPayments = makeData<
  GetLoanDataForApplyPaymentsResponse,
  GetLoanDataForApplyPaymentsKey,
  GetLoanDataForApplyPaymentsVariables
>({
  method: 'get',
  name: 'getLoanDataForApplyPayments',
  summary: 'Get loan data for apply payments',
  path: '/companies/{companyId}/people/{personId}/loans/{loanId}/loan-data-for-apply-payments',
  queryKey: ({ query, companyId, personId, loanId }) => [
    'companies',
    companyId,
    'people',
    personId,
    'loans',
    loanId,
    'loan-data-for-apply-payments',
    query,
  ],
})
